import React, { use, useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import dayjs from "dayjs";
import "../../../styles/Auth/employee.css";
import { EMPLOYEE_ROLES } from "../../../utils/constants.js";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import trayUpload from "@iconify/icons-mdi/tray-upload";
import { Switch, Tooltip, Typography } from '@mui/material';
import { postData, uploadFile, getData, putData, deleteData } from "../../../webService/webservice.js";
import StoreMultiSelect from "../../Challange/storeMultiSelect.jsx";
import TVFMLoader from "../Loader/loader.jsx";
const AddEmployeeForm = ({
    defaultRole,
    onSuccess,
    onCancel,

}) => {

    const EMPTY_ARRAY = [];
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    // const departmentId = params.get("departmentId");
    const loggedInRole = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const initialStoreId = adminStoreIds[0] || "";
    const isAddEmployee = location.pathname === '/employees/add';
    const [searchQuery, setSearchQuery] = useState('');
    const [previewUrl, setPreviewUrl] = useState(null);
    const [IdPreviewUrl, setIdPreviewUrl] = useState(null);
    const [emailError, setEmailError] = useState("");
    const [employeeImage, setEmployeeImage] = useState(null);
    const [IdProofImage, setIdProofImage] = useState(null);
    const [users, setUsers] = useState([]);
    // const [stores, setStores] = useState([]);
    // const [departments, setDepartments] = useState([]);
    const [open, setOpen] = useState(false);
    const [storeOptions, setStoreOptions] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [employeeToDelete, setEmployeeToDelete] = useState(null);
    const [limit, setLimit] = useState(5);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const sessionToken = localStorage.getItem("Token");
    const [isEditMode, setIsEditMode] = useState(false);
    const [editEmployeeId, setEditEmployeeId] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [passwordMatchError, setPasswordMatchError] = useState('');
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isAttendanceMode, setIsAttendanceMode] = useState(false);
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState(-1);
    const sort = [[sortField, sortOrder]];
    const [selectedStores, setSelectedStores] = useState([]);
    const [dynamicRoles, setDynamicRoles] = useState([]);

    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const response = await getData('roles', {}, sessionToken);
                if (response?.data) {
                    setDynamicRoles(response.data);
                }
            } catch (error) {
                console.error("Failed to fetch dynamic roles", error);
            }
        };
        fetchRoles();
    }, [sessionToken, refreshKey]);

    const [isAddRoleModalOpen, setIsAddRoleModalOpen] = useState(false);
    const [newRoleData, setNewRoleData] = useState({ roleName: '', isPasswordRequired: true });

    const handleAddRole = async () => {
        if (!newRoleData.roleName.trim()) {
            toast.error("Role name is required");
            return;
        }
        try {
            const token = localStorage.getItem("Token");
            const response = await postData('roles', newRoleData, token);
            if (response?.status === 200 || response?.success) {
                toast.success("Role added successfully");

                // 1. Update dynamic roles locally so it appears in dropdown immediately
                setDynamicRoles(prev => [...prev, { roleName: newRoleData.roleName, isPasswordRequired: newRoleData.isPasswordRequired }]);

                // 2. Automatically select the new role
                setFormData(prev => ({ ...prev, role: newRoleData.roleName }));

                setIsAddRoleModalOpen(false);
                setNewRoleData({ roleName: '', isPasswordRequired: true });
                setRefreshKey(prev => prev + 1);
            } else {
                toast.error(response?.message || "Failed to add role");
            }
        } catch (error) {
            console.error("Add Role Error:", error);
            toast.error("An error occurred while adding the role");
        }
    };

    function calculateAge(dob) {
        if (!dob) return "";
        const today = new Date();
        const birthDate = new Date(dob);

        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();

        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    }

    function validateIdProof(idProoftype, idProofNumber) {
        switch (idProoftype) {
            case "Ration Card":
                // usually alphanumeric 10–20 chars
                return /^[A-Z0-9]{10,20}$/i.test(idProofNumber);

            case "Voter ID":
                // 3 letters + 7 digits (e.g., ABC1234567)
                return /^[A-Z]{3}[0-9]{7}$/i.test(idProofNumber);

            case "Aadhaar":
                // exactly 12 digits
                return /^[0-9]{12}$/.test(idProofNumber);

            case "PAN CARD":
                // 5 letters + 4 digits + 1 letter (e.g., ABCDE1234F)
                return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i.test(idProofNumber);
            case "Passport":
                // 1 letter + 7 digits (e.g., A1234567)
                return /^[A-PR-WYa-pr-wy][0-9]{7}$/.test(idProofNumber);

            case "Driving License":
                // 2 letters + 2 digits + 11 digits (e.g., TN10XXXXXXXXXXX)
                return /^[A-Z]{2}[0-9]{2}[0-9]{11}$/.test(idProofNumber);

            default:
                return false;
        }
    }
    const handleSort = (field) => {
        const newOrder =
            sortField === field ? (sortOrder === 1 ? -1 : 1) : -1;

        setSortField(field);
        setSortOrder(newOrder);
    };
    const [showLoader, setShowLoader] = useState(false);
    const [loaderText, setLoaderText] = useState('');

    const [currentDateTime, setCurrentDateTime] = useState("");

    const [selectedStoreId, setSelectedStoreId] = useState(
        initialStoreId
    );
    const [errors, setErrors] = useState({});
    const selectedStoreCount = selectedStores?.length || 0;

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        role: '',
        phoneNumber: '',
        gender: '',
        employeeImageObject: '',
        password: '',
        confirmPassword: '',
        staffId: '',
        dateOfBirth: '',
        dateOfJoining: '',
        dateOfResignation: '',
        age: '',
        currentAddress: '',
        permanentAddress: '',
        bloodGroup: '',
        emergencyContactPerson: '',
        emergencyContactNumber: '',
        idProoftype: '',
        idProofNumber: '',
        refferedByName: '',
        refferedByContactNumber: '',
        storeIds: initialStoreId ? [initialStoreId] : [],
        hasPosAccess: false

    });

    useEffect(() => {
        if (initialStoreId) {
            const fetchStoreLabel = async () => {
                try {
                    const token = localStorage.getItem("Token");
                    const res = await getData(`stores/store/${initialStoreId}`, {}, token);
                    if (res?.data) {
                        setSelectedStores([{ value: res.data._id, label: res.data.storeName }]);
                    }
                } catch (err) {
                    console.error("Failed to fetch initial store label in Employee Form", err);
                }
            };
            fetchStoreLabel();
        }
    }, [initialStoreId]);

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const validateEmail = (email) => {
        // Basic RFC 5322 official email regex simplified
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleEmailChange = (e) => {
        const email = e.target.value;
        setFormData((prev) => ({ ...prev, email }));

        if (!validateEmail(email)) {
            setEmailError("Please enter a valid email address");
        } else {
            setEmailError("");
        }
    };

    const roleObj = dynamicRoles.find(r => r.roleName === formData.role);
    const isPasswordRequired = formData.role === "ClusterManager" ? true : (roleObj ? roleObj.isPasswordRequired : true);


    const validateFields = (data, employeeImage) => {
        let newErrors = {};

        if (!data.name?.trim()) newErrors.name = "Name is required";
        if (!data.phoneNumber) newErrors.phoneNumber = "Phone number is required";
        else if (!/^[6-9]\d{9}$/.test(data.phoneNumber))
            newErrors.phoneNumber = "Enter a valid phone number";

        if (!data.email) newErrors.email = "Email is required";
        else if (!/^\S+@\S+\.\S+$/.test(data.email))
            newErrors.email = "Invalid email format";

        if (isPasswordRequired) {
            if (!data.password) newErrors.password = "Password is required";
            else if (data.password.length < 6)
                newErrors.password = "Min 6 characters";

            if (!data.confirmPassword)
                newErrors.confirmPassword = "Confirm password is required";
            else if (data.password !== data.confirmPassword)
                newErrors.confirmPassword = "Passwords do not match";
        }

        if (!data.dateOfJoining) newErrors.dateOfJoining = "Date of Joining is required";

        return newErrors;
    };

    const handleAddEmployee = async (e) => {
        e.preventDefault();

        const validationErrors = validateFields(formData, employeeImage);
        console.log('Validation Errors:', validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            Object.entries(validationErrors).forEach(([key, value]) => {
                toast.error(value);
            });
            return;
        }

        setShowLoader(true);
        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            if (employeeImage && userId) {
                const employeeUpload = await uploadFile(
                    `files/upload/${userId}`,
                    employeeImage
                );

                const employeeImagePath = employeeUpload?.data?.uri;

                if (!employeeImagePath) {
                    toast.error("File upload failed. Please try again.");
                    return;
                }

                if (employeeUpload?.status === 200) {
                    const employeeData = {
                        name: formData.name,
                        email: formData.email,
                        gender: formData.gender,
                        role: formData.role,
                        phoneNumber: formData.phoneNumber,
                        employeeImageObject: employeeUpload?.formData?.employeeImageObject,
                        staffId: formData.staffId,
                        dateOfBirth: formData.dateOfBirth,
                        dateOfJoining: formData.dateOfJoining,
                        age: formData.age,
                        password: isPasswordRequired ? (formData.password || "") : formData.phoneNumber,
                        hasPosAccess: formData.hasPosAccess === true
                    };

                    if (Array.isArray(formData.storeIds) && formData.storeIds.length > 0) {
                        employeeData.storeIds = formData.storeIds;
                    }

                    console.log("Sending employee data:", employeeData);

                    const response = await postData("users/signup", employeeData, token);

                    if (response?.status === 200 || response?.success) {
                        toast.success(response.message || "Employee added successfully");

                        setFormData({
                            name: "",
                            email: "",
                            phoneNumber: "",
                            role: "",
                            gender: "",
                            employeeImageObject: "",
                            staffId: "",
                            password: "",
                            confirmPassword: "",
                            dateOfBirth: "",
                            dateOfJoining: "",
                            dateOfResignation: "",
                            age: "",
                            currentAddress: "",
                            storeIds: "",
                            permanentAddress: "",
                            bloodGroup: "",
                            emergencyContactPerson: "",
                            emergencyContactNumber: "",
                            idProoftype: "",
                            idProofNumber: "",
                            refferedByName: "",
                            refferedByContactNumber: ""
                        });

                        setEmployeeImage(null);
                        setIdProofImage(null);
                        setPreviewUrl(null);
                        setErrors({});
                        if (onSuccess) {
                            onSuccess(response.data);
                        } else {
                            navigate("/stores/add");
                        }
                        triggerRefresh();
                    } else {
                        toast.error(response?.message || "Failed to add employee");
                    }
                } else {
                    toast.error(employeeUpload?.message || "Image upload failed");
                }
            }
        } catch (error) {
            console.error("Add Employee Error:", error);
            toast.error(error.message || "Add Employee Failed");
        } finally {
            setTimeout(() => {
                setShowLoader(false);
            }, 2000);
        }
    };

    let allowedEmployeeRoles = [];

    // All roles that can be managed in the employee section
    const baseEmployeeRoles = EMPLOYEE_ROLES; // This includes fixed roles like StoreAdmin, Biller, etc.
    const allAvailableRoles = [...baseEmployeeRoles, ...dynamicRoles.map(r => r.roleName)];

    if (["FranchiseAdmin", "SelfAdmin"].includes(loggedInRole)) {
        // Can create all roles except themselves
        allowedEmployeeRoles = allAvailableRoles.filter(role => role !== "SuperAdmin" && role !== "FranchiseAdmin" && role !== "SelfAdmin");
    }
    else if (loggedInRole === "SuperAdmin") {
        allowedEmployeeRoles = allAvailableRoles.filter(role => role !== "SuperAdmin" && role !== "FranchiseAdmin" && role !== "SelfAdmin" && role !== "ClusterManager");
    }
    else if (loggedInRole === "StoreAdmin") {
        allowedEmployeeRoles = allAvailableRoles.filter(role => role !== "ClusterManager" && (["StoreManager", "Biller"].includes(role) || dynamicRoles.some(dr => dr.roleName === role)));
    }
    else if (loggedInRole === "ClusterManager") {
        allowedEmployeeRoles = allAvailableRoles.filter(role => role !== "ClusterManager" && (["StoreAdmin", "StoreManager", "Biller"].includes(role) || dynamicRoles.some(dr => dr.roleName === role)));
    }
    else if (loggedInRole === "StoreManager") {
        allowedEmployeeRoles = allAvailableRoles.filter(role => role !== "ClusterManager" && (role === "Biller" || dynamicRoles.some(dr => dr.roleName === role)));
    }
    else {
        allowedEmployeeRoles = [];
    }



    const formatDateTime = (dateStr) => {
        if (!dateStr) return "";
        return new Date(dateStr).toISOString().slice(0, 16);
    };

    const loadStores = async (inputValue, loadedOptions, { page }) => {
        try {
            const res = await getData(
                "stores/stores",
                { page, limit: 10, search: inputValue },
                sessionToken
            );

            const results = res?.data?.results || EMPTY_ARRAY;

            const options = results.map(store => ({
                value: store._id,
                label: store.storeName
            }));

            return {
                options,
                hasMore: results.length === 10,
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Store Fetch Failed", err);
            return { options: [], hasMore: false };
        }
    };

    const handleChange = e => {
        const { name, value } = e.target;
        // For firstName and lastName: only alphabets, no spaces
        if ((name === 'firstName' || name === 'lastName')) {

            if (/[^a-zA-Z]/.test(value)) return;

            const capitalizedValue =
                value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();

            setFormData((prev) => ({
                ...prev,
                [name]: capitalizedValue,
            }));
            return;
        }

        if (name === 'confirmPassword' || name === 'password') {
            const newPassword = name === 'password' ? value : formData.password;
            const newConfirm = name === 'confirmPassword' ? value : formData.confirmPassword;

            if (newPassword && newConfirm && newPassword !== newConfirm) {
                setPasswordMatchError('Passwords do not match');
            } else {
                setPasswordMatchError('');
            }
        }

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <form className="employee-form" onSubmit={handleAddEmployee}>
                <div className="employee-form-row">
                    <div className="employee-form-group-image">
                        <div className="image-upload-wrapper">
                            <div className="image-placeholder">
                                <img
                                    src={previewUrl || '/assets/mdi--user.svg'}
                                    alt="Preview"
                                    className="round-image"
                                />
                            </div>
                        </div>
                        <div className="upload-icon-container">
                            <label htmlFor="employeeImage" className="upload-icon-btn">
                                Upload Image
                                <Icon icon={trayUpload} width="24" height="24" />
                                <input
                                    type="file"
                                    id="employeeImage"
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file && file.size > 1024 * 1024) {
                                            toast.error("Image size exceeds the maximum allowed limit (1 MB).");
                                            e.target.value = "";
                                            return;
                                        }
                                        setEmployeeImage(file);
                                        setPreviewUrl(URL.createObjectURL(file));
                                    }}
                                />

                            </label>
                            {errors.employeeImage && <p className="field-error">{errors.employeeImage}</p>}
                        </div>
                    </div>
                </div>
                <div className="employee-form-row">
                    <div className="employee-form-group">
                        <label htmlFor="name" className="input-label">
                            Name<span className="required">*</span>
                        </label>
                        <input
                            type="text"
                            placeholder="Enter employee name"
                            className="category-input"
                            value={formData.name}
                            onChange={e =>
                                setFormData(prev => ({ ...prev, name: e.target.value }))
                            }
                        />
                        {errors.name && <p className="field-error">{errors.name}</p>}
                    </div>
                    <div className="employee-form-group">
                        <label htmlFor="email" className="input-label">
                            Email
                            <span className="required">*</span>
                        </label>
                        <input
                            type="email"
                            className="category-input"
                            placeholder="Enter Email"
                            // disabled={!formData.phoneNumber}
                            value={formData.email || ""}
                            onChange={handleEmailChange}
                        />
                        {errors.email && <p className="field-error">{errors.email}</p>}
                    </div>
                    <div className="employee-form-group">
                        <label htmlFor="phoneNumber" className="input-label">
                            Mobile Number
                            <span className="required">*</span>
                        </label>
                        <input
                            type="text"
                            className="category-input"
                            placeholder="Enter Mobile Number"
                            // disabled={!formData.role}
                            maxLength={10}
                            title="Mobile Number must be exactly 10 digits"
                            value={formData.phoneNumber}
                            onChange={(e) => {
                                const value = e.target.value;
                                // Allow only digits and max 10 characters
                                if (/^\d{0,10}$/.test(value)) {
                                    setFormData((prev) => ({ ...prev, phoneNumber: value }));
                                }
                            }}
                        // onBlur={() => {
                        //     if (formData.phoneNumber.length !== 10) {
                        //         alert("Mobile Number must be exactly 10 digits");
                        //     }
                        // }}
                        />
                        {errors.phoneNumber && <p className="field-error">{errors.phoneNumber}</p>}
                    </div>
                </div>
                <div className="employee-form-row">
                    <div className="employee-form-group">
                        <label className="input-label">Stores</label>

                        <StoreMultiSelect
                            value={selectedStores}
                            onChange={(val) => {
                                setSelectedStores(val);
                                setFormData(prev => ({
                                    ...prev,
                                    storeIds: val.map(v => v.value)
                                }));
                            }}
                            loadStores={loadStores}
                            loggedInRole={loggedInRole}
                            assignedStoreIds={adminStoreIds}
                        />
                    </div>
                    <div className="employee-form-group">
                        <label htmlFor="role" className="input-label">
                            Role
                            <span className="required">*</span>
                        </label>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <select
                                id="role"
                                className="category-input"
                                value={formData.role}
                                onChange={(e) => setFormData(prev => ({ ...prev, role: e.target.value }))}
                                style={{ flex: 1 }}
                            >
                                <option value="">Select Role</option>

                                {allowedEmployeeRoles
                                    .filter(role => {
                                        // ❌ Hide ClusterManager if only ONE store selected
                                        if (role === "ClusterManager" && (formData.storeIds?.length || 0) === 1) {
                                            return false;
                                        }
                                        return true;
                                    })
                                    .map(role => (
                                        <option key={role} value={role}>
                                            {role}
                                        </option>
                                    ))
                                }

                            </select>
                            <Tooltip title="Add New Role">
                                <div
                                    onClick={() => setIsAddRoleModalOpen(true)}
                                    style={{
                                        cursor: 'pointer',
                                        display: 'flex',
                                        padding: '8px',
                                        borderRadius: '8px',
                                        backgroundColor: '#f1f5f9',
                                        color: '#1e293b',
                                        border: '1px solid #e2e8f0'
                                    }}
                                >
                                    <Icon icon="mdi:plus" width={20} height={20} />
                                </div>
                            </Tooltip>
                        </div>
                        {errors.role && <p className="field-error">{errors.role}</p>}
                    </div>
                    <div className="employee-form-group">
                        <label htmlFor="gender" className="input-label">
                            Gender
                        </label>
                        <span className="required">*</span>
                        <select
                            id="gender"
                            className="category-input"
                            placeholder="Select Gender"
                            // disabled={!formData.email}
                            value={formData.gender}
                            onChange={(e) => {
                                const selectedgendertype = e.target.value;
                                setFormData((prev) => ({ ...prev, gender: selectedgendertype }))
                            }}
                        >
                            <option value='' >Select Gender</option>
                            <option value='Male'>Male</option>
                            <option value='Female'>Female</option>
                            <option value='Other'>Other</option>
                        </select>
                        {errors.gender && <p className="field-error">{errors.gender}</p>}
                    </div>
                    <div className="employee-form-group">
                        <label htmlFor="StaffId" className="input-label">
                            StaffId
                        </label>
                        <input
                            type="text"
                            name="staffId"
                            placeholder="StaffId"
                            disabled={true}
                            onChange={e =>
                                setFormData(prev => ({ ...prev, staffId: e.target.value }))
                            }
                            value={formData.staffId}
                            className="department-input"
                        />
                    </div>
                </div>
                {isPasswordRequired && (
                    <div className="employee-form-row">
                        {/* Password */}
                        <div className="employee-form-group">
                            <label className="input-label">
                                Password <span className="required">*</span>
                            </label>

                            <div className="password-container" style={{ position: "relative" }}>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    placeholder="Password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    className="password-input"

                                />
                                {errors.password && <p className="field-error">{errors.password}</p>}

                                <div
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="password-show"
                                    role="button"
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </div>
                            </div>

                        </div>

                        {/* Confirm Password */}
                        <div className="employee-form-group">
                            <label className="input-label">
                                Confirm Password <span className="required">*</span>
                            </label>

                            <div className="password-container" style={{ position: "relative" }}>
                                <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    name="confirmPassword"
                                    placeholder="Confirm Password"
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                    className="password-input"
                                />
                                {errors.confirmPassword && <p className="field-error">{errors.confirmPassword}</p>}
                                <div
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    className="password-show"
                                    role="button"
                                >
                                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {loggedInRole === "SuperAdmin" && (
                    <div className="employee-form-row">
                        <div className="employee-form-group" style={{ flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                            <label className="input-label" style={{ marginBottom: 0 }}>Grant POS Access</label>
                            <Switch
                                checked={formData.hasPosAccess === true}
                                onChange={(e) => setFormData(prev => ({ ...prev, hasPosAccess: e.target.checked }))}
                                sx={{
                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                        color: '#3C0008',
                                    },
                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                        backgroundColor: '#3C0008',
                                    },
                                }}
                            />
                        </div>
                    </div>
                )}

                <div className="employee-form-row">
                    <div className="employee-form-group">
                        <label htmlFor="dateOfBirth" className="input-label">
                            Date Of Birth
                        </label>
                        <input
                            name="dateOfBirth"
                            placeholder="enter Date Of Birth"
                            type="date"
                            className="department-input"
                            value={formData.dateOfBirth || ""}
                            onChange={(e) => {
                                const dob = e.target.value;
                                const age = calculateAge(dob);

                                setFormData({
                                    ...formData,
                                    dateOfBirth: dob,
                                    age: age
                                });
                            }}
                        />
                        {errors.dateOfBirth && <p className="field-error">{errors.dateOfBirth}</p>}
                    </div>
                    <div className="employee-form-group">
                        <label htmlFor="dateOfJoining" className="input-label">
                            Date of Joining
                            <span className="required">*</span>
                        </label>

                        <input
                            type="date"
                            id="dateOfJoining"
                            className="department-input"
                            value={formData.dateOfJoining || ""}
                            onChange={(e) =>
                                setFormData(prev => ({ ...prev, dateOfJoining: e.target.value }))
                            }
                        />

                        {errors.dateOfJoining && <p className="field-error">{errors.dateOfJoining}</p>}
                    </div>
                    <div className="employee-form-group">
                        <label htmlFor="dateOfResignation" className="input-label">
                            Date of Resignation
                        </label>

                        <input
                            type="date"
                            id="dateOfResignation"
                            className="department-input"
                            value={formData.dateOfResignation || ""}
                            onChange={(e) =>
                                setFormData(prev => ({ ...prev, dateOfResignation: e.target.value }))
                            }
                        />

                        {errors.dateOfResignation && (
                            <p className="field-error">{errors.dateOfResignation}</p>
                        )}
                    </div>

                    <div className="employee-form-group">
                        <label htmlFor="age" className="input-label">
                            Age
                        </label>
                        <input
                            type="number"
                            className="department-input"
                            value={formData.age || ""}
                            readOnly
                        />
                    </div>
                </div>
                <div className="employee-form-row">
                    <div className="employee-form-group">
                        <label htmlFor="bloodGroup" className="input-label">
                            Blood Group
                        </label>
                        <input
                            name="bloodGroup"
                            placeholder="Enter Blood Group"
                            type="text"
                            className="department-input"
                            onChange={e =>
                                setFormData(prev => ({ ...prev, bloodGroup: e.target.value }))
                            }
                            value={formData.bloodGroup}
                        />
                    </div>
                    <div className="employee-form-group">
                        <label htmlFor="idProoftype" className="input-label">
                            ID Proof Type
                        </label>
                        <select
                            id="idProoftype"
                            className="category-input"
                            placeholder="Select id Proof type"
                            // disabled={!formData.email}
                            value={formData.idProoftype}
                            onChange={(e) => {
                                const selectedidProoftypetype = e.target.value;
                                setFormData((prev) => ({ ...prev, idProoftype: selectedidProoftypetype }))
                            }}
                        >
                            <option value='' >Select id Proof type</option>
                            <option value='Voter ID'>VOTER ID</option>
                            <option value='Aadhaar'>AADHAR</option>
                            <option value='Driving License'>DRIVING LICENSE</option>
                        </select>
                        {errors.idProoftype && <p className="field-error">{errors.idProoftype}</p>}
                    </div>
                    <div className="employee-form-group">
                        <label htmlFor="idProofNumber" className="input-label">
                            ID Proof Number
                        </label>
                        <input
                            id="idProofNumber"
                            type="text"
                            className="category-input"
                            placeholder="Enter ID Proof Number"
                            value={formData.idProofNumber || ""}
                            onChange={(e) => {
                                const value = e.target.value;
                                setFormData((prev) => ({ ...prev, idProofNumber: value }));

                                // validate live
                                if (formData.idProoftype) {
                                    const isValid = validateIdProof(formData.idProoftype, value);
                                    setFormData((prev) => ({ ...prev, idProofValid: isValid }));
                                }
                            }}
                        />
                        {errors.idProofNumber && <p className="field-error">{errors.idProofNumber}</p>}
                    </div>
                </div>
                <div className="employee-form-row">
                    <div className="employee-form-group" style={{ flex: '1 1 50%' }}>
                        <label className="input-label">Current Address</label>
                        <textarea
                            name="currentAddress"
                            placeholder="Enter Current Address"
                            className="category-input"
                            style={{ height: '80px' }}
                            value={formData.currentAddress}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="employee-form-group" style={{ flex: '1 1 50%' }}>
                        <label className="input-label">Permanent Address</label>
                        <textarea
                            name="permanentAddress"
                            placeholder="Enter Permanent Address"
                            className="category-input"
                            style={{ height: '80px' }}
                            value={formData.permanentAddress}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="employee-form-row">
                    <div className="employee-form-group">
                        <label className="input-label">Emergency Contact Person</label>
                        <input
                            type="text"
                            name="emergencyContactPerson"
                            placeholder="Enter Name"
                            className="category-input"
                            value={formData.emergencyContactPerson}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="employee-form-group">
                        <label className="input-label">Emergency Contact Number</label>
                        <input
                            type="text"
                            name="emergencyContactNumber"
                            placeholder="Enter Number"
                            className="category-input"
                            maxLength={10}
                            value={formData.emergencyContactNumber}
                            onChange={(e) => {
                                if (/^\d{0,10}$/.test(e.target.value)) {
                                    handleChange({ target: { name: 'emergencyContactNumber', value: e.target.value } });
                                }
                            }}
                        />
                    </div>
                </div>
                <div className="employee-form-row">
                    <div className="employee-form-group">
                        <label className="input-label">Referred By (Name)</label>
                        <input
                            type="text"
                            name="refferedByName"
                            placeholder="Referred By Name"
                            className="category-input"
                            value={formData.refferedByName}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="employee-form-group">
                        <label className="input-label">Referred By (Contact)</label>
                        <input
                            type="text"
                            name="refferedByContactNumber"
                            placeholder="Referred By Contact"
                            className="category-input"
                            maxLength={10}
                            value={formData.refferedByContactNumber}
                            onChange={(e) => {
                                if (/^\d{0,10}$/.test(e.target.value)) {
                                    handleChange({ target: { name: 'refferedByContactNumber', value: e.target.value } });
                                }
                            }}
                        />
                    </div>
                </div>
                <div className="employee-buttons">
                    <button className="add-Product-button" type="submit" disabled={emailError !== ""} onClick={handleAddEmployee}>
                        Add Employee
                    </button>
                    <button type="button" className="cancel-Product-button" onClick={onCancel || (() => navigate('/stores/add'))}>
                        cancel
                    </button>
                </div>
            </form>

            {/* Add Role Modal */}
            {isAddRoleModalOpen && (
                <div className="popup-overlay" style={{ zIndex: 10000 }}>
                    <div className="user-popup-wrapper" style={{ maxWidth: '400px', height: 'auto', padding: '30px' }}>
                        <Icon
                            icon="mdi:close-circle-outline"
                            className="popup-close-icon-outside"
                            onClick={() => setIsAddRoleModalOpen(false)}
                        />
                        <Typography variant="h6" textAlign="center" mb={3}>Add New Role</Typography>
                        <div className="employee-form-group" style={{ marginBottom: '20px' }}>
                            <label className="input-label">Role Name</label>
                            <input
                                type="text"
                                className="category-input"
                                placeholder="e.g. Senior Stylist"
                                value={newRoleData.roleName}
                                onChange={e => setNewRoleData(prev => ({ ...prev, roleName: e.target.value }))}
                            />
                        </div>
                        <div className="employee-form-group" style={{ marginBottom: '30px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Switch
                                checked={newRoleData.isPasswordRequired}
                                onChange={e => setNewRoleData(prev => ({ ...prev, isPasswordRequired: e.target.checked }))}
                            />
                            <label className="input-label" style={{ marginBottom: 0 }}>Requires Password Login?</label>
                        </div>
                        <div style={{ display: 'flex', gap: '15px' }}>
                            <button
                                className="cancel-Product-button"
                                style={{ flex: 1 }}
                                onClick={() => setIsAddRoleModalOpen(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="Add-Product-button"
                                style={{ flex: 1, backgroundColor: '#3C0008', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}
                                onClick={handleAddRole}
                            >
                                Create Role
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AddEmployeeForm;